import { Component, InjectReactive } from 'vue-property-decorator'
import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'

@Component({
    components: {},
})
export default class ClvrScreenControlCellAbstract extends ClvrComponent {
    @InjectReactive({ from: 'printMode', default: false })
    protected printMode!: string
}
